import * as React from 'react';
import { Button } from '@cian/ui-kit';
import cx from 'clsx';

import * as styles from './OnboardingSwitcher.css';

type TProps = {
  hasPrevButton?: boolean;
  hasNextButton?: boolean;
  hasFinishButton?: boolean;
  onPrevClick: () => void;
  onNextClick: () => void;
  onFinishClick?: () => void;
  isMobile?: boolean;
};

export const OnboardingSwitcher: React.FC<TProps> = ({
  hasPrevButton,
  hasNextButton,
  hasFinishButton,
  onPrevClick,
  onNextClick,
  onFinishClick,
  isMobile,
}) => {
  return (
    <div className={cx(styles['container'], isMobile && styles['container_mobile'])} data-testid="OnboardingSwitcher">
      {hasPrevButton && (
        <Button theme="fill_secondary" size="L" onClick={onPrevClick} fullWidth={isMobile}>
          Назад
        </Button>
      )}
      {hasNextButton && (
        <Button size="L" onClick={onNextClick} fullWidth={isMobile}>
          Дальше
        </Button>
      )}
      {hasFinishButton && (
        <Button size="L" onClick={onFinishClick} fullWidth={isMobile}>
          Добавить объект
        </Button>
      )}
    </div>
  );
};
